/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

// override to fix the ootb issue, when select pick-up and save without select/display the default billing address
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    FindDefaultBillTo,
} from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SetInitialValues";
import { BillToModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = Parameters<typeof FindDefaultBillTo>[0];

export const CustomFindDefaultBillTo = (props: HandlerType) => {
    const state = props.getState();
    const session = state.context.session;
    const currentBillTo = session.billToId;
    const defaultBillToId = session.properties.defaultBillToId || currentBillTo;
    props.defaultBillTo = defaultBillToId ? ({ id: defaultBillToId, isDefault: true } as BillToModel) : undefined;
};

replaceInChain(chain, FindDefaultBillTo, CustomFindDefaultBillTo);
